export default "__VITE_ASSET__CVit0a3k__"